import { useQuery } from "@tanstack/react-query";
import { validateRemoteFile } from "./api";

const remoteFileQueryStaleTimeMs = 0;

export const remoteFileKeys = {
  all: ["devplane", "remotefiles"] as const,
  validations: () => [...remoteFileKeys.all, "validation"] as const,
  validation: (fileUrl: string) =>
    [...remoteFileKeys.validations(), fileUrl] as const,
};

export function remoteFileValidationQueryOptions(fileUrl: string) {
  return {
    queryKey: remoteFileKeys.validation(fileUrl),
    queryFn: () => validateRemoteFile(fileUrl),
    staleTime: remoteFileQueryStaleTimeMs,
  };
}

export function useRemoteFileValidationQuery(
  fileUrl: string,
  enabled: boolean = true,
) {
  return useQuery({
    ...remoteFileValidationQueryOptions(fileUrl),
    enabled: enabled && Boolean(fileUrl),
  });
}
